module.exports = __webpack_public_path__ + "img/pic_bluecdz.4446145e.png";